<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Alternância do ranking de procura entre imóveis e bairros.
defineProps({
  modelValue: { type: String, default: 'imoveis' },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="border-b border-lais-border-rule px-4 sm:px-6 lg:px-10">
    <div
      class="flex flex-col gap-2 py-3 sm:flex-row sm:items-center sm:justify-between"
    >
      <p class="text-[12px] font-semibold text-lais-text-muted">
        Ranking de procura
      </p>
      <div class="flex items-center gap-6 overflow-x-auto no-scrollbar">
        <button
          type="button"
          class="relative py-3 text-[14px] font-semibold transition-colors"
          :class="
            modelValue === 'imoveis'
              ? 'text-lais-primary'
              : 'text-lais-text-muted hover:text-lais-text-body'
          "
          @click="emit('update:modelValue', 'imoveis')"
        >
          Imóveis
          <span
            v-if="modelValue === 'imoveis'"
            class="absolute bottom-0 left-0 right-0 h-[3px] bg-lais-primary rounded-t"
          />
        </button>
        <button
          type="button"
          class="relative py-3 text-[14px] font-semibold transition-colors"
          :class="
            modelValue === 'bairros'
              ? 'text-lais-primary'
              : 'text-lais-text-muted hover:text-lais-text-body'
          "
          @click="emit('update:modelValue', 'bairros')"
        >
          Bairros
          <span
            v-if="modelValue === 'bairros'"
            class="absolute bottom-0 left-0 right-0 h-[3px] bg-lais-primary rounded-t"
          />
        </button>
      </div>
    </div>
  </div>
</template>
